<template>
    <div>
        <vue-headful :title="'Products ('+productCount+') - AMOS365'" />

        <h4 class="page-header">
            Products ({{ productCount }})

            <router-link to="/products/create" class="btn btn-sm btn-info" v-if="canEdit">
                <i class="fas fa-plus-square"></i> Create
            </router-link>
            <router-link to="/products/import" class="btn btn-sm btn-light" v-if="canEdit">
                <span class="text-success"><i class="fas fa-file-excel"></i> Import</span>
            </router-link>
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="productsTable" url="/products" :columns="columns" :options="options">

                    <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                    </div>

                    <div slot="afterFilter" class="ml-2">
                        <button class="btn btn-sm btn-default" v-on:click="clearFilters()" title="Clear All Filters">
                            <i class="fas fa-ban"></i>
                        </button>
                        <button class="btn btn-sm btn-default" v-on:click="showFilters = !showFilters" title="Apply Filters">
                            <i class="fas fa-filter"></i>
                            <span class="badge badge-danger" v-if="filterCount > 0">{{ filterCount }}</span>
                        </button>
                        <b-dropdown variant="default" size="sm" :disabled="exportingTable">
                            <template #button-content>
                                <i class="fa fa-file-excel"></i> Export
                            </template>
                            <b-dropdown-item href="#" v-on:click="exportTable('products')">Products Only</b-dropdown-item>
                            <b-dropdown-item href="#" v-on:click="exportTable('levels')">Products And Levels</b-dropdown-item>
                        </b-dropdown>
                    </div>

                    <template slot="product_name" slot-scope="props">
                        <router-link :to="`/products/view/${props.row.id}`">{{ props.row.product_name }}</router-link>
                    </template>

                    <template slot="carrier_name" slot-scope="props">
                        <router-link :to="`/carriers/view/${props.row.carrier_id}`">{{ props.row.carrier_name }}</router-link>
                    </template>

                    <template slot="product_expires_at" slot-scope="props">
                        <span v-if="props.row.product_expires_at">{{ props.row.product_expires_at | moment("MM/DD/YYYY") }}</span>
                    </template>

                    <template slot="is_active" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                        <label class="badge badge-warning" v-else-if="props.row.is_active == 0">Inactive</label>
                    </template>

                    <template slot="created_at" slot-scope="props">
                        <span v-if="props.row.created_at">{{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                    </template>

                    <template slot="updated_at" slot-scope="props">
                        <span v-if="props.row.updated_at">{{ props.row.updated_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                    </template>
                </v-server-table>
            </div>
        </div>

        <b-modal v-model="showFilters" :ref="'productListFilters'" title="Agent Filters" size="lg" no-fade ok-title="Apply Filters" @ok="applyFilters()" :static="true">
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Product Type:</div>
                <div class="col-md-7 col-12">
                    <v-select v-model="filters['products.product_type_id']" :options="productTypes" :reduce="type => type.id" label="product_type_name" placeholder="-- Select a Product Type --" multiple />
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                exportingTable: false,
                showFilters: false,
                loadFilters: true,
                productCount: null,
                userTimezone: this.$root.timezone,
                productTypes: [],

                columns: ['product_name', 'product_type_name', 'carrier_name', 'product_desc', 'product_expires_at', 'product_website', 'is_active', 'created_at', 'updated_at'],
                options: {
                    headings: {
                        product_name: 'Product',
                        product_type_name: 'Product Type',
                        carrier_name: 'Carrier',
                        product_desc: 'Description',
                        product_expires_at: 'Expiration',
                        product_website: 'Website',
                        is_active: 'Active',
                        created_at: 'Date Created',
                        updated_at: 'Date Last Updated',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'products.product_name',
                    },
                    texts:{
                        filterPlaceholder:"Search Products",
                    },
                    responseAdapter: (response) => {
                        //Set the count
                        this.productCount = response.data.count;

                        //Check for filters
                        if(response.data.filters)
                        {
                            //Set the filters
                            this.setFilters(response.data.filters);
                        }

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Load the Filters
                        if(this.loadFilters)
                        {
                            //Append it
                            data.load_filters = true;

                            //Cancel it
                            this.loadFilters = false;
                        }

                        //Add the type
                        data.filters = this.filters;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },

                filters: {
                    'products.product_type_id': [],
                },
            }
        },

        watch: {

        },

        computed: {

            canEdit(){
                //Check Permissions
                return this.$root.hasPermission(['products.manage']);
            },

            filterCount(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(typeof this.filters[keys[i]] === 'object' && !Array.isArray(this.filters[keys[i]]) && this.filters[keys[i]] !== null)
                    {
                        //Check the Logic
                        if(this.filters[keys[i]]['logic'] != null)
                        {
                            count++;
                        }
                    }
                    else if(Array.isArray(this.filters[keys[i]]) && this.filters[keys[i]].length > 0)
                    {
                        count++;
                    }
                    else if(this.filters[keys[i]] != null && this.filters[keys[i]] != '')
                    {
                        count++;
                    }
                }

                //Send it
                return count;
            },
        },

        methods: {
            setFilters(data){
                //Set all
                this.productTypes = data.productTypes;
            },

            applyFilters(){
                //Apply the filters
                this.$refs.productsTable.refresh();
            },

            clearFilters(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(typeof this.filters[keys[i]] === 'object' && !Array.isArray(this.filters[keys[i]]) && this.filters[keys[i]] !== null)
                    {
                        this.filters[keys[i]] = {
                            'logic': null,
                            'value': null,
                            'value2': null,
                        };
                    }
                    else if(Array.isArray(this.filters[keys[i]]))
                    {
                        this.filters[keys[i]] = [];
                    }
                    else
                    {
                        this.filters[keys[i]] = null;
                    }
                }

                //Refresh
                this.$refs.productsTable.refresh();
            },

            exportTable(export_type = 'products'){
                //Loading indicator
                this.exportingTable = true;

                //Build the Filters
                //var filters = filterExtractor.extractFilters(this.filters);

                //Setup Columns
                var cols = JSON.parse(JSON.stringify(this.$refs.productsTable.columns));

                //Build the payload
                var payload = {
                    //filters: filters,
                    query: (this.$refs.productsTable.getRequestParams()).query,
                    orderBy: this.$refs.productsTable.options.orderBy.column,
                    ascending: this.$refs.productsTable.options.orderBy.ascending,
                    table: 'productsTable',
                    columns: cols,
                    export: true,
                    export_type: export_type,
                };

                //Send it
                this.$http.get('/products', payload)
                    .then(response => {
                        //Open the new window to Download the File
                        if(response.data.queued)
                        {
                            //Alert the User
                            this.$toastr.s(response.data.message);
                        }
                        else
                        {
                            //Open the download URL
                            window.open(response.data.url);
                        }
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.e(JSON.stringify(err), 'Failed to Export');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },
        },

        mounted() {
            //Focus on the SEarch Input
            this.$refs.productsTable.$refs.genericFilter.focus();
        }
    }
</script>
